import { FooterConfigBlockState } from './types';

const defaultState: FooterConfigBlockState = {
    settings: {
        fontSize: 100,
        text: 'START WRITING YOUR FOOTER',
        backgroundColor: '#16161d',
        showDataSources: false,
    },
    databilities: [],
};

export default defaultState;
